"use strict";

var PlanMap = function () {
  var planMap = null;
  var mapLayers = null;

  var loadPlanMap = function () {
    const activeGroupId = Tree.get("activeGroup", "groupId");
    const lastGroupId = Tree.get("lastGroupId", "plan");
    var firstLoad = false;

    initLayers();

    if (!planMap) {
      firstLoad = true;
      TreeUpdates.turnOnUpdates(mapLayers, getActivePlanMap, getCurrentPlanBasemap, "plan");

      planMap = initPlanMap();

      DisplayOptions.startLegendListeners("plan", mapLayers);
      loadLayerListenersForPlanMap();
    }

    if (firstLoad || activeGroupId !== lastGroupId) {
      if (Progeny.activeHasProgeny()) {
        loadPlanRegulatorMap();
      } else {
        loadPlanMS4Map();
      }
    }

    reloadListeners();
    CommonMapFunctions.afterMapLoad();
  };

  var initLayers = function () {
    if (!mapLayers) {
      mapLayers = LayerFunctions.getAllLayersAsMapLayers();
    }
  };

  var loadLayerListenersForPlanMap = function () {
    // @TODO: Set up config to load layer listneres dynamically
    const FlowRoutingLayer = require("../outfalls/flowRoutingLayer");
    FlowRoutingLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const OutfallsSimpleLayer = require("../outfalls/outfallsSimpleLayer");
    OutfallsSimpleLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const RunoffOpportunityLayer = require("../telr/runoffOpportunityLayer");
    RunoffOpportunityLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const ParticulatesOpportunityLayer = require("../telr/particulatesOpportunityLayer");
    ParticulatesOpportunityLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const RunoffRatioOpportunityLayer = require("../telr/runoffRatioOpportunityLayer");
    RunoffRatioOpportunityLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const StreamsEsriDynamicMapLayer = require("../general/streamsEsriDynamicMapLayer");
    StreamsEsriDynamicMapLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const LitterHotspotEsriDynamicMapLayer = require("../trash/litterHotspotEsriDynamicMapLayer");
    LitterHotspotEsriDynamicMapLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");

    const ParcelsPluEsriDynamicMapLayer = require("../general/parcelsPluEsriDynamicMapLayer");
    ParcelsPluEsriDynamicMapLayer.loadLayerListenersForMap(planMap, mapLayers, "plan");
  };

  var loadPlanMS4Map = function () {
    const annualReportingCallback = function () {
      initializePlanLayers();
    };
    if (Tree.get("annualReportingLoaded")) {
      annualReportingCallback();
    } else {
      Actions.loadAnnualReporting(annualReportingCallback);
    }

    CommonMapFunctions.afterMS4MapLoad(planMap);
  };

  var loadPlanRegulatorMap = function () {
    Ms4Table.loadListeners();
    RegionAreaLayer.loadLayer();
  };

  var reloadListeners = function () {
    Table.loadListeners("plan");
    DisplayOptions.startLegendListeners("plan", mapLayers);
    CatchmentView.startListeners();

    if (Progeny.activeHasProgeny()) {
      Ms4Table.loadListeners();
    }
  };

  var initializePlanLayers = function () {
    const autoLoadLayers = ["catchments", "ms4Boundary"];
    autoLoadLayers.forEach((layerName) => {
      loadLayer(layerName);
    });
  };

  var loadLayer = function (layerName) {
    switch (layerName) {
      case "catchments":
        Tree.set(["extentInitialized", "plan"], false);
        Tree.set(["layers", "plan", "catchments", "isEnabled"], true);
        break;
      case "ms4Boundary":
        Tree.set(["layers", "plan", "ms4Boundary", "isEnabled"], true);
        break;
    }
  };

  var initPlanMap = function () {
    planMap = L.map("planMap", {
      zoomControl: false,
      tileLayer: {
        maxNativeZoom: 21,
      },
      minZoom: 3,
      maxZoom: 21,
    });
    CommonMapFunctions.setMapHeight("planMap", "plan");
    mapLayers.basemap = MapFunctions.addBasemap(planMap, mapLayers.basemap, "Gray");

    BasemapFunctions.setBasemap("Gray", "plan");

    L.control
      .scale({
        position: "bottomright",
        metric: false,
      })
      .addTo(planMap);
    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(planMap);
    planMap.setView(Tree.get("activeGroup", "latlng"), 14);
    MapPaneFunctions.createCustomMapPanes(planMap);

    return planMap;
  };

  var getActivePlanMap = function () {
    return planMap;
  };

  var getActiveLayers = function () {
    initLayers();
    return mapLayers;
  };

  var getCurrentPlanBasemap = function () {
    return mapLayers.basemap;
  };

  return {
    loadPlanMap,
    loadPlanMS4Map,
    loadPlanRegulatorMap,
    getActivePlanMap,
    getActiveLayers,
  };
};

module.exports = PlanMap();

const CommonMapFunctions = require("../mapFunctions/commonMapFunctions");
const Tree = require("../../tree");
const TreeUpdates = require("../mapFunctions/treeUpdates");
const Table = require("../mapFunctions/table");
const RegionAreaLayer = require("../general/regionAreaLayer");
const Actions = require("../actions");
const DisplayOptions = require("../mapFunctions/displayOptions");
const CatchmentView = require("../mapFunctions/catchmentView");
const BasemapFunctions = require("../mapFunctions/basemapFunctions");
const Ms4Table = require("../ms4Table");
const Progeny = require("../../login/progeny");
const LayerFunctions = require("../mapFunctions/layerFunctions");
const MapPaneFunctions = require("../mapFunctions/mapPaneFunctions");
const MapFunctions = require("../mapFunctions/mapFunctions");
